var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxOutlinePathSquare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m14.51 12.8-3.29-3.29a.742.742 0 0 1-.1-.93l1.03-1.63c.33-.53.85-.86 1.44-.92.65-.07 1.33.19 1.85.71l1.85 1.85c.5.5.75 1.18.68 1.85-.07.6-.39 1.12-.89 1.44l-1.63 1.03c-.14.08-.28.11-.41.11-.19 0-.39-.08-.53-.22zm.64-1.48 1.12-.71c.14-.09.19-.23.2-.34a.813.813 0 0 0-.25-.63L14.37 7.8c-.2-.2-.43-.3-.62-.28-.14.02-.25.09-.34.23l-.71 1.12 2.45 2.45z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.68 17.34c-.48-.48-.71-1.18-.62-1.92l.6-5.07c.2-1.69 1.02-2.37 2.74-2.26l2.39.14c.41.03.73.38.7.79-.03.41-.38.73-.79.7l-2.4-.13c-.97-.06-1.06.09-1.16.94l-.6 5.07c-.03.28.04.53.19.68.16.16.4.23.68.19l5.07-.6c.92-.11 1.03-.25.95-1.13l-.15-2.42c-.02-.41.29-.77.7-.79.41-.03.77.29.79.7l.14 2.39c.17 1.68-.53 2.54-2.26 2.74l-5.07.6c-.09.02-.19.02-.29.02-.62 0-1.2-.23-1.61-.64z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.96 17.05a.754.754 0 0 1 0-1.06l1.85-1.85c.29-.29.77-.29 1.06 0 .29.29.29.77 0 1.06l-1.85 1.85a.71.71 0 0 1-.53.22c-.19 0-.38-.07-.53-.22z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 22.75c-5.43 0-7.75-2.32-7.75-7.75V9c0-5.43 2.32-7.75 7.75-7.75h6c5.43 0 7.75 2.32 7.75 7.75v6c0 5.43-2.32 7.75-7.75 7.75H9zM2.75 9v6c0 4.61 1.64 6.25 6.25 6.25h6c4.61 0 6.25-1.64 6.25-6.25V9c0-4.61-1.64-6.25-6.25-6.25H9C4.39 2.75 2.75 4.39 2.75 9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlinePathSquare);
export default __webpack_public_path__ + "static/media/vuesax-outline-path-square.d9c233ac26466da924caa27a0335ef01.svg";
export { ForwardRef as ReactComponent };